mutation changeContext($input: ChangeContextInput!) {
  base {
    changeContext(input: $input) {
      workspaceId
      scenarioId
      originId
      __typename
    }
    __typename
  }
}
